import { render } from "./SideMenuDocVersionCom.vue?vue&type=template&id=19183091&scoped=true"
import script from "./SideMenuDocVersionCom.vue?vue&type=script&lang=js"
export * from "./SideMenuDocVersionCom.vue?vue&type=script&lang=js"

import "@/assets/process_steps.css?vue&type=style&index=0&id=19183091&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19183091"]])

export default __exports__